<template>
	<Loader v-if="loading" />
	<div v-else>
		<div class="margin-bottom" v-for="record in records">
			<div>{{ record.comment }}</div>
			<div class="note small-margin-top">
				Created <Format style="display: inline-block;" :time="true" type="date" :value="record.created_at" />
				|
				<span class="link" v-on:click="deleteComment(record.id)">Delete</span>
			</div>
		</div>
		<div>
			<textarea cols="50" rows="4" :disabled="saving" v-model="comment"></textarea>
			<div class="small-margin-top">
				<button :disabled="saving" v-on:click="submit()">Submit</button>
			</div>
		</div>
	</div>
</template>

<script>
/**
	 * @see https://app.nuclino.com/AnnoAnno/Laravel/Comments-API-d9fea9b5-d1f5-47b9-8a86-da9f6a569302
	 */

import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  props: [
    'resource',
    'id',
    'sources'
  ],
  data: () => ({
    loading: false,
    saving: false,
    records: [],
    comment: ''
  }),
  computed: {
    ...mapGetters([])
  },
  methods: {
    deleteComment (id) {
      Vue.$api.delete('/comments/' + this.resource + '/' + this.id + '/' + id, {}, {
        loader: toggle => this.saving = toggle,
        callback: () => this.load()
      })
    },
    submit () {
      Vue.$api.post('/comments/' + this.resource + '/' + this.id, {
        comment: this.comment
      }, {
        loader: toggle => this.saving = toggle,
        callback: () => this.load()
      })
    },
    load () {
      var sources = this.sources ? JSON.stringify(this.sources) : ''

      Vue.$api.get('/comments/' + this.resource + '/' + this.id + '?sources=' + sources, {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: data => this.parse(data)
      })
    },
    parse (data) {
      console.log(data)
      this.records = data
    }
  },
  created () {
    this.load()
  }
}
</script>
